import React from "react";
import ReactWOW from "react-wow";
import { Link } from "gatsby";

const Banner = () => {
  return (
    <section className="it-services-banner">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7 col-md-12">
            <div className="main-banner-content">
              <ReactWOW delay=".1s" animation="fadeInUp">
                <span className="banner-badge">
                  Microsoft Cloud Transformation, Security & Digital Workplace Partner
                </span>
              </ReactWOW>

              <ReactWOW delay=".2s" animation="fadeInUp">
                <h1>
                  Build, Secure and Govern Microsoft Cloud Environments That Help Your Business Grow
                </h1>
              </ReactWOW>

              <ReactWOW delay=".3s" animation="fadeInUp">
                <p>
                  CloudLogic IT Solutions helps organisations implement,
                  optimise, secure, and govern Microsoft 365, Azure, SharePoint,
                  Teams, OneDrive, identity, compliance, and digital workplace
                  systems so technology becomes a growth enabler instead of an
                  operational risk.
                </p>
              </ReactWOW>

              <ReactWOW delay=".4s" animation="fadeInUp">
                <div className="btn-box">
                  <Link to="/contact" className="default-btn">
                    Book Microsoft 365 Health Check
                  </Link>

                  <Link to="/services" className="default-btn secondary-btn">
                    Explore Transformation Services
                  </Link>
                </div>
              </ReactWOW>

              <ReactWOW delay=".5s" animation="fadeInUp">
                <div className="banner-points">
                  <span>Modernise Operations</span>
                  <span>Improve Collaboration</span>
                  <span>Secure and Govern Microsoft Cloud</span>
                </div>
              </ReactWOW>
            </div>
          </div>

          <div className="col-lg-5 col-md-12">
            <ReactWOW delay=".3s" animation="fadeInUp">
              <div className="banner-visual-wrap">
                <div className="hero-risk-panel">
                  <div className="risk-panel-header">
                    <div>
                      <span className="risk-panel-eyebrow">
                        Microsoft Cloud Growth Roadmap
                      </span>
                      <h3>From setup and migration to secure digital workplace maturity</h3>
                    </div>

                    <span className="risk-status-badge">Advisory Ready</span>
                  </div>

                  <div className="risk-score-row">
                    <div className="risk-score-card high">
                      <span>Priority</span>
                      <strong>Build</strong>
                      <small>Tenant setup</small>
                    </div>

                    <div className="risk-score-card medium">
                      <span>Exposure</span>
                      <strong>Optimise</strong>
                      <small>Productivity</small>
                    </div>

                    <div className="risk-score-card stable">
                      <span>Outcome</span>
                      <strong>Govern</strong>
                      <small>Compliance</small>
                    </div>
                  </div>

                  <div className="risk-control-list">
                    <div className="risk-control-item">
                      <span className="risk-dot high"></span>
                      <div>
                        <strong>Microsoft 365 setup, migration and licensing</strong>
                        <small>Create the right foundation for users, data, and growth</small>
                      </div>
                    </div>

                    <div className="risk-control-item">
                      <span className="risk-dot medium"></span>
                      <div>
                        <strong>SharePoint, Teams, OneDrive and workflows</strong>
                        <small>Improve collaboration, document management, and automation</small>
                      </div>
                    </div>

                    <div className="risk-control-item">
                      <span className="risk-dot stable"></span>
                      <div>
                        <strong>Identity, security and compliance readiness</strong>
                        <small>Secure access, protect data, and prepare for audits</small>
                      </div>
                    </div>
                  </div>

                  <div className="risk-panel-footer">
                    <span>Microsoft 365 Health Check</span>
                    <span>Transformation roadmap</span>
                  </div>
                </div>
              </div>
            </ReactWOW>
          </div>
        </div>

        <ReactWOW delay=".6s" animation="fadeInUp">
          <div className="hero-trust-strip">
            <div>
              <span>We build</span>
              <strong>Microsoft 365, Azure, SharePoint, Teams</strong>
            </div>

            <div>
              <span>We optimise</span>
              <strong>Licensing, workflows, collaboration, productivity</strong>
            </div>

            <div>
              <span>We secure and govern</span>
              <strong>Identity, Defender, Purview, Intune, compliance</strong>
            </div>

            <div>
              <span>We advise</span>
              <strong>Ongoing technology guidance and managed support</strong>
            </div>
          </div>
        </ReactWOW>
      </div>
    </section>
  );
};

export default Banner;
